export const err = (msg: string) => {
  throw new Error(msg);
};
